import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--services"
export default class extends Controller {
  static values = {
    show: String
  }

  static targets = [
    "form",
    "content",
    "showFormButton",
    "showContentButton"
  ]

  connect() {
    this.elFormTarget = document.querySelector("[data-admins--services-target='form']")
    this.elContentTarget = document.querySelector("[data-admins--services-target='content']")
    this.elButtonTarget = document.querySelector("[data-admins--services-target='showFormButton']")

    if (this.showValue === "form" || this.actionValue === "edit") {
      this.elFormTarget.classList.remove("hidden")
      this.elContentTarget.classList.add("hidden")
    }

    if (this.showValue === "content") {
      this.elContentTarget.classList.remove("hidden")
      this.elFormTarget.classList.add("hidden")

      this.elButtonTarget.classList.remove("hidden")
    }
  }

  showForm() {
    this.formTarget.classList.remove("hidden")
    this.contentTarget.classList.add("hidden")

    this.showFormButtonTarget.classList.add("hidden")
  }

  showContent() {
    this.formTarget.classList.add("hidden")
    this.contentTarget.classList.remove("hidden")

    this.showFormButtonTarget.classList.remove("hidden")
  }
}
